import { useTranslation } from "react-i18next"
import { ResourceContentSection } from "@/components/molecules/ResourceContentSection/ResourceContentSection"

export function TermsContent() {
  const { t } = useTranslation()

  const contentItems = [
    { type: "heading1" as const, content: t("terms.introduction.title") },
    { type: "paragraph" as const, content: t("terms.introduction.content") },

    { type: "heading2" as const, content: t("terms.acceptance.title") },
    { type: "paragraph" as const, content: t("terms.acceptance.content") },

    { type: "heading2" as const, content: t("terms.modification.title") },
    { type: "paragraph" as const, content: t("terms.modification.content") },

    { type: "heading2" as const, content: t("terms.services.title") },
    { type: "heading2" as const, content: t("terms.services.eligibility.title") },
    { type: "paragraph" as const, content: t("terms.services.eligibility.content") },

    { type: "heading2" as const, content: t("terms.services.conduct.title") },
    { type: "paragraph" as const, content: t("terms.services.conduct.content") },
    {
      type: "list" as const,
      content: [
        t("terms.services.conduct.item1"),
        t("terms.services.conduct.item2"),
        t("terms.services.conduct.item3"),
        t("terms.services.conduct.item4"),
        t("terms.services.conduct.item5"),
      ],
    },

    { type: "heading2" as const, content: t("terms.services.security.title") },
    { type: "paragraph" as const, content: t("terms.services.security.content") },

    { type: "heading2" as const, content: t("terms.privacy.title") },
    { type: "paragraph" as const, content: t("terms.privacy.content") },

    { type: "heading2" as const, content: t("terms.ip.title") },
    { type: "heading2" as const, content: t("terms.ip.ownership.title") },
    { type: "paragraph" as const, content: t("terms.ip.ownership.content") },
    { type: "heading2" as const, content: t("terms.ip.license.title") },
    { type: "paragraph" as const, content: t("terms.ip.license.content") },

    { type: "heading2" as const, content: t("terms.termination.title") },
    { type: "paragraph" as const, content: t("terms.termination.content") },

    { type: "heading2" as const, content: t("terms.dispute.title") },
    { type: "heading2" as const, content: t("terms.dispute.law.title") },
    { type: "paragraph" as const, content: t("terms.dispute.law.content") },
    { type: "heading2" as const, content: t("terms.dispute.arbitration.title") },
    { type: "paragraph" as const, content: t("terms.dispute.arbitration.content") },

    { type: "heading2" as const, content: t("terms.liability.title") },
    { type: "paragraph" as const, content: t("terms.liability.content") },

    { type: "heading2" as const, content: t("terms.contact.title") },
    { type: "paragraph" as const, content: t("terms.contact.content") },

    { type: "heading2" as const, content: t("terms.conclusion.title") },
    { type: "paragraph" as const, content: t("terms.conclusion.content") },
  ]

  return <ResourceContentSection items={contentItems} />
}
